import React, { useState, useEffect } from 'react';
import {
    Button,
    TextField,
    Checkbox,
    FormControlLabel,
    Grid,
    Typography,
    Box,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    CircularProgress,
    createTheme,
    ThemeProvider,
    Card,
    CardContent,
    Snackbar,
    AppBar,
    Toolbar,
    Tab,
    Tabs
} from '@mui/material';
import axios from 'axios';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';
import { styled } from '@mui/system';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Fade } from '@mui/material';
import SubmittedData from './SubmittedData';
import EmvVerifiedSection from './EmvVerifiedSection';
import EmailVerifications from './EmailVerifications';
import SectionApply from './SectionApply';

const API_URL = process.env.REACT_APP_API_URL;

const SectionContainer = styled(Box)({
    background: '#000000',
    borderRadius: '20px',
    padding: '20px', // Default padding for larger screens
    marginBottom: '20px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
    color: '#ffffff',
});

const CustomInputLabel = styled(InputLabel)({
    color: 'rgba(255, 255, 255, 0.7)',
});

const CustomButton = styled(Button)({
    backgroundColor: '#E90FF',
    color: '#fff',
    padding: '10px 20px',
    borderRadius: '6px',
    '&:hover': {
        backgroundColor: '#E90FF',
    },
});

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#ffffff',
        },
        secondary: {
            main: '#f48fb1',
        },
        background: {
            default: '#000000',
            paper: '#000000',
        },
        text: {
            primary: '#ffffff',
            secondary: '#b0bec5',
        },
    },
});

const Verification = ({ onLogout }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('userId');

    const [formData, setFormData] = useState({
        user_id: userId,
        aadhar: '',
        pan: '',
        bank_account: '',
        aadhar_file: null,
        pan_file: null,
        bank_account_file: null,
        ifsc: '',
        interview_slots: [],
        terms_accepted: false,
    });

    const [dataExists, setDataExists] = useState(false);
    const [submittedData, setSubmittedData] = useState(null);
    const [email, setEmail] = useState(null)
    const [role, setRole] = useState('');
    const [error, setError] = useState([]);

    const [selectedTab, setSelectedTab] = useState(0); // Track which tab is selected
    const [isEmailChangeRequested, setIsEmailChangeRequested] = useState(false);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const handleChangeEmailClick = () => {
        setIsEmailChangeRequested(true); // Set this state to true when the button is clicked
    };

    useEffect(() => {
        const fetchVerificationData = async () => {
            try {
                const response = await axios.get(`${API_URL}/check_user_verification/?user_id=${userId}`);
                if (response.data.success) {
                    setFormData(response.data.data);
                    setSubmittedData(response.data.data);
                    setDataExists(true);
                } else {
                    setDataExists(false);
                }
            } catch (error) {
                setDataExists(false);
            }
        };
        fetchVerificationData();
    }, [userId]);

    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                const response = await axios.get(`${API_URL}/get-user-role/`, {
                    params: { user_id: userId },
                });
                setRole(response.data.role);
                setEmail(response.data.email);
            } catch (err) {
                if (err.response) {
                    setError(err.response.data.error);
                } else {
                    setError("Something went wrong");
                }
            }
        };
        fetchUserRole();
    }, [userId]);

    return (
        <div>
            {/* Title */}
            <Typography
                variant="h3"
                component="h1"
                align="center"
                fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
                sx={{
                    backgroundImage: 'linear-gradient(45deg, #ff00ff, #00bfff)',
                    mt: 10,
                    WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
                    color: 'transparent',  // Makes the text itself transparent to show the gradient
                }}
                gutterBottom
            >
                Verification Portal
            </Typography>

            <ThemeProvider theme={darkTheme}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100vh',
                        backgroundColor: darkTheme.palette.background.default,
                    }}
                >
                    {/* Header */}
                    <Header1 userId={userId} onLogout={onLogout} />

                    <Box position="static">
                        <Toolbar sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <Tabs value={selectedTab} onChange={handleTabChange} centered>
                                <Tab
                                    label="Email Verification"
                                    sx={{
                                        color: selectedTab === 0 ? '#1E90FF' : 'white',
                                    }}
                                />
                                <Tab
                                    label="Kyc Verification"
                                    sx={{
                                        color: selectedTab === 1 ? '#1E90FF' : 'white',
                                    }}
                                />

                            </Tabs>
                        </Toolbar>
                    </Box>

                    {/* Main Content */}
                    <Box sx={{ flexGrow: 1, paddingX: 2, paddingTop: 3 }}>
                        {selectedTab === 0 && (
                            <SectionContainer>
                                {role === 'user' ? (
                                    <>

                                        <EmailVerifications userId={userId} />
                                    </>
                                ) : (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#000000', padding: 3, textAlign: 'center' }}>
                                        {!isEmailChangeRequested ? (
                                            <>
                                                <Typography variant="h6" color="white" sx={{ marginBottom: 2 }}>
                                                    Your email: {email}
                                                </Typography>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    sx={{
                                                        padding: '10px 20px',
                                                        borderRadius: '8px',
                                                        borderColor: '#fff',
                                                        color: '#fff',
                                                        '&:hover': {
                                                            backgroundColor: '#333',
                                                            borderColor: '#fff',
                                                        }
                                                    }}
                                                    onClick={handleChangeEmailClick} // Trigger the email change
                                                >
                                                    Change Email
                                                </Button>
                                            </>
                                        ) : (
                                            <>
                                                <Typography variant="h6" color="primary">
                                                    Please verify your email:
                                                </Typography>
                                                <EmailVerifications userId={userId} />
                                            </>
                                        )}
                                    </Box>
                                )}
                            </SectionContainer>
                        )}

                        {selectedTab === 1 && (
                            <SectionContainer>
                                {dataExists ? (
                                    <>
                                        <SubmittedData userId={userId} formData={formData} submittedData={submittedData} />
                                    </>
                                ) : (
                                    <>

                                        <EmvVerifiedSection userId={userId} />
                                    </>
                                )}
                            </SectionContainer>
                        )}

                        {selectedTab === 2 && (
                            <SectionContainer>
                                {submittedData ? (
                                    <SectionApply userId={userId} formData={formData} submittedData={submittedData} />
                                ) : (
                                    <Typography variant="h6" color="white">
                                        Please complete your KYC verification.
                                    </Typography>
                                )}
                            </SectionContainer>
                        )}
                    </Box>

                    {/* Footer */}
                    <Box sx={{ marginTop: 'auto' }}>
                        <Footer2 />
                    </Box>
                </Box>
            </ThemeProvider>
        </div>
    );
};

export default Verification;
